import { Text, Icon } from '@cad-arc';
import classNames from 'classnames';
import React from 'react';
import { NarrativeRowNavProps } from '../hooks/use-narrative-keyboard-nav/use-narrative-keyboard-nav';
import styles from './pinned-divider-row.module.css';

export function PinnedDividerRow({
    hiddenCount,
    isExpanded,
    isFirstResponder = false,
    isAscending = false,
    onToggle,
    rowNavProps,
}: {
    hiddenCount: number;
    isExpanded: boolean;
    isFirstResponder?: boolean;
    /** DESC lays the divider out after the pinned rows and before the
     *  chronological list, so its default styling rounds its own bottom edge
     *  and pushes its separating gap below itself. ASC reverses the combined
     *  list order (chronological, then divider, then pinned rows), so the
     *  divider needs the mirror image: round the top, push the gap above. */
    isAscending?: boolean;
    onToggle: () => void;
    rowNavProps?: NarrativeRowNavProps;
}): React.JSX.Element {
    return (
        <div
            className={classNames(styles['divider'], {
                [styles['lg']]: isFirstResponder,
                [styles['reversed']]: isAscending,
            })}
            onClick={onToggle}
            data-testid="PINNED_DIVIDER_ROW"
            role="button"
            ref={rowNavProps?.ref}
            tabIndex={rowNavProps ? rowNavProps.tabIndex : 0}
            onFocus={rowNavProps?.onFocus}
            onKeyDown={(e) => {
                rowNavProps?.onKeyDown(e);
                if (e.defaultPrevented) return;
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    onToggle();
                }
            }}
        >
            <Text className={styles['toggle-text']}>
                {isExpanded ? 'Show less' : `Expand all pinned (${hiddenCount} more)`}
                <Icon
                    size="sm"
                    icon="TriangleDown"
                    className={classNames(styles['toggle-icon'], {
                        [styles['toggle-icon-expanded']]: isExpanded,
                    })}
                />
            </Text>
        </div>
    );
}
